// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"288ba434","371":"7c2a596f","482":"31ecc1a8"}[chunkId] + ".chunk.js";
};